import React from 'react';
import PropTypes from 'prop-types';
import {t} from '../../Translations'
import Label from './Label';
import Button from "../widgets/Button";



class LabelButtonLabel extends React.PureComponent {
  
  render() {
    const {index, label,classLabel, classes, onClick, disabled,data,onChange} = this.props;

  return (
    
    <div key={index} className="row my-4 my-md-2">
  <div className="col-12 col-md-6 step1-label info-bulle">
    <Label>{`${t('Step1_form_rims')}*`}</Label>
  </div>

      <div className="col-12 col-md-6">
      <Label className={classLabel}> {label} </Label>
      <Button 
      className={classes} onClick={onClick} disabled={disabled} data={data} onChange={onChange}>
              {t('Step1_form_info_update')}
      </Button>
      </div>
  </div>
);
}}

  LabelButtonLabel.propTypes = {
    index: PropTypes.number,
    //label: PropTypes.string.isRequired,
    classes: PropTypes.string,
    //data: choiceDataPropTypes.isRequired,
    disabled: PropTypes.bool,
    classLabel: PropTypes.string,
    onClick: PropTypes.func
  };
  
  LabelButtonLabel.defaultProps = {
    index: 0,
    value: undefined,
    //loading: false
    classLabel:""
  };
  
  export default LabelButtonLabel;


// WEBPACK FOOTER //
// ./src/components/widgets/LabelButtonLabel.js